if(!customElements.get('custom-featured-product-list')){
    class CustomFeaturedProductList extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.infoPanels = this.querySelectorAll('.featured-product-list__info');
            this.productPanels = this.querySelectorAll('.featured-product-list__products');
            this.collectionCards = this.querySelectorAll('.featured-product-list__collection-card');
            this.updateActiveCards('1');

            this.navigations = this.querySelectorAll('.featured-product-list__navigation');
            this.navigations.forEach(item => {
                item.addEventListener('click', this.switchCollection.bind(this));
                item.addEventListener('keydown', (event) => {
                    if(event.key === 'Enter'){
                        this.switchCollection(event);
                    }
                })
            })

            this.querySelectorAll('.swiper-container').forEach(item => {
                this.initSwiper(item);
            });
        }

        switchCollection(e){
            const idx = e.currentTarget.dataset.idx;

            this.navigations.forEach(item => {
                item.classList.toggle('active', item.dataset.idx === idx);
            })

            this.updateActiveCards(idx);

            this.infoPanels.forEach(item => {
                item.setAttribute('data-active', item.dataset.idx === idx ? 'true' : 'false');
            })

            this.productPanels.forEach(item => {
                const active = item.dataset.idx === idx;
                item.setAttribute('data-active', active ? 'true' : 'false');

                if(active){
                    this.initSwiper(item.querySelector('.swiper-container'));
                }
            })
        }

        updateActiveCards(idx){
            this.collectionCards.forEach(item => {
                item.classList.toggle('active', item.dataset.idx === idx);
            })
        }

        initSwiper(swiperContainer){
            if(!swiperContainer) return;

            // switching collections re-inits the swiper on a now-visible container;
            // destroy the previous instance first so instances don't stack
            if(swiperContainer.swiper){
                swiperContainer.swiper.destroy(true, true);
            }

            const panel = swiperContainer.closest('.featured-product-list__products') || this;

            const totalSlides = parseInt(swiperContainer.dataset.totalSlides);
            const itemsPerView = parseInt(swiperContainer.dataset.numPerView) || 4;
            const itemsPerViewMobile = parseInt(swiperContainer.dataset.numPerViewMobile) || 1;

            // merchant settings, capped only by how many slides actually exist
            const slidesPerView = Math.min(itemsPerView, totalSlides);
            const slidesPerViewMobile = Math.min(itemsPerViewMobile, totalSlides);

            let loop = swiperContainer.dataset.loop == 'true';
            if(totalSlides == 1) loop = false;

            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 0,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    // below 992px the layout stacks (same breakpoint as the CSS):
                    // use the mobile setting; from 992px use the desktop setting
                    0: {
                        slidesPerView: slidesPerViewMobile
                    },
                    992: {
                        slidesPerView: slidesPerView
                    }
                },
                observer: true,
                observeSlideChildren: true
            }

            if(panel.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: panel.querySelector('.swiper-pagination')
                }
            }

            if(panel.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: panel.querySelector('.swiper-button-next'),
                    prevEl: panel.querySelector('.swiper-button-prev')
                }
            }

            if(swiperContainer.dataset.autoplay == 'true'){
                let speed = swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            var swiper = new Swiper(swiperContainer, swiperSettings);
            this.getVisibleSlides(swiper);

            this.checkPagination(panel);
            this.updatePaginationWrapperMargin(panel);

            swiper.on('slideChange', () => {
                this.getVisibleSlides(swiper);
            });

            swiper.on('resize', () => {
                this.checkPagination(panel);
                this.updatePaginationWrapperMargin(panel);
            });
        }

        getVisibleSlides(swiper){
            if(swiper){
                const allSlides = swiper.slides;
                const activeIndex = swiper.activeIndex;
                const slidesPerView = swiper.params.slidesPerView;

                const visibleSlides = [];

                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }

                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });

                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        updatePaginationWrapperMargin(panel){
            let paginationWrapper = panel.querySelector('.swiper-pagination-wrapper');
            if(!paginationWrapper) return;

            if(panel.querySelectorAll('.swiper-pagination-bullet').length > 1){
                paginationWrapper.classList.add('my-5')
            }else{
                paginationWrapper.classList.remove('my-5')
            }
        }

        checkPagination(panel){
            var pagination = panel.querySelector('.swiper-pagination');
            var btns = {
                prev: panel.querySelector('.swiper-button-prev'),
                next: panel.querySelector('.swiper-button-next')
            }

            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.style.display = 'none';
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                // clear the inline style so the stylesheet (e.g. display: flex
                // on the arrow buttons) stays in control
                if(pagination) pagination.style.display = '';
                if(btns.prev) btns.prev.style.display = '';
                if(btns.next) btns.next.style.display = '';
            }
        }
    }

    customElements.define('custom-featured-product-list', CustomFeaturedProductList);
}
